import { AutoArchivePreviewResult, AutoArchiveAllCompaniesResult } from "src/api-service";

// **************************************************************************
// AUTO-ARCHIVE STATE
// **************************************************************************
export interface AutoArchiveLoadingState {
    loadingPreview: boolean;
    executing: boolean;
}

export interface AutoArchiveState {
    preview: AutoArchivePreviewResult | undefined;
    result: AutoArchiveAllCompaniesResult | undefined;
    loading: AutoArchiveLoadingState;
}

export const initialAutoArchiveState: AutoArchiveState = {
    preview: undefined,
    result: undefined,
    loading: { loadingPreview: false, executing: false },
};
